import React from 'react';
import { Header } from '../components/Header';
import { ZakatWizard } from '../components/ZakatWizard';
export function Home() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-576">
      <Header data-id="element-577" />

      <main className="py-12 px-4 sm:px-6 lg:px-8" data-id="element-578">
        <div className="max-w-7xl mx-auto" data-id="element-579">
          <div className="mb-12 text-center max-w-2xl mx-auto" data-id="element-580">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-serif mb-6 tracking-tight" data-id="element-581">
              Zakat Calculator
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-582">
              Calculate your Zakat accurately according to Islamic principles.
              Our step-by-step wizard helps you determine your net assets and
              Zakat obligations.
            </p>
          </div>

          <ZakatWizard data-id="element-583" />
        </div>
      </main>

      <footer className="bg-white border-t border-gray-100 py-12 mt-12 pb-28 lg:pb-12" data-id="element-584">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-500 text-sm" data-id="element-585">
          <p data-id="element-586">© {new Date().getFullYear()} PiF Finance. All rights reserved.</p>
          <p className="mt-2" data-id="element-587">
            Disclaimer: This calculator is for educational purposes. Please
            consult with a scholar for specific rulings.
          </p>
        </div>
      </footer>
    </div>;
}